/**
 * 要素が横スクロール可能かどうかをチェックする関数
 * @param {HTMLElement} element - チェックする要素
 * @returns {boolean} - 横スクロール可能な場合はtrue
 *
 * @example
 * const element = document.querySelector('.scroll-container');
 * if (isHorizontallyScrollable(element)) {
 *   console.log('横スクロールできるよ！');
 * }
 */
const isHorizontallyScrollable = (element) => {
    return element.scrollWidth > element.clientWidth;
};

const element = document.querySelector(".Breadcrumb__scroll");
if (element) {
    if (isHorizontallyScrollable(element)) {
        element.parentNode.classList.add("is-scrollable");
    } else {
        element.parentNode.classList.add("isnt-scrollable");
    }
}
